/*
 * JANGIN Chef Mingoo Challenge — registration form.
 *
 * Validation is inline and fires on blur, not only on submit, so nobody
 * discovers six problems at once after pressing the button.
 *
 * The form is inert until the section is marked live, which needs BOTH a
 * submit endpoint and an Official Rules URL. See the section comment.
 */
(function () {
  var section = document.querySelector('.jangin-challenge-register');
  if (!section) return;

  var inner = section.querySelector('.jangin-challenge-register__inner');
  var form = inner.querySelector('.jangin-challenge-register__form');
  var live = inner.dataset.live === 'yes';
  var endpoint = inner.dataset.endpoint;

  var display = form.querySelector('#cr-display');
  var handle = form.querySelector('#cr-handle');
  var email = form.querySelector('#cr-email');
  var formErr = inner.querySelector('.jangin-challenge-register__formerr');
  var busy = false;

  function setState(s) { inner.setAttribute('data-state', s); }
  function fieldErr(id, msg) {
    var p = inner.querySelector('.jangin-challenge-register__err[data-for="' + id + '"]');
    if (!p) return;
    p.textContent = msg || '';
    var input = form.querySelector('#' + id);
    if (input) input.setAttribute('aria-invalid', msg ? 'true' : 'false');
  }

  // ---- Handle -------------------------------------------------------------
  // The @ is rendered as a prefix, so strip any the visitor types themselves
  // rather than rejecting it. Lowercase, because handles are case-insensitive
  // and the ledger has to match them.
  handle.addEventListener('blur', function () {
    handle.value = handle.value.trim().replace(/^@+/, '').toLowerCase();
  });

  // TikTok, when enabled, only relabels. Scoring is identical on both.
  var platformRadios = form.querySelectorAll('input[name="platform"]');
  var handleLabel = form.querySelector('[data-handle-label]');
  Array.prototype.forEach.call(platformRadios, function (r) {
    r.addEventListener('change', function () {
      if (!handleLabel || r.type !== 'radio') return;
      handleLabel.textContent = r.value === 'tiktok' ? 'TikTok handle' : 'Instagram handle';
    });
  });

  // ---- Validation ---------------------------------------------------------
  var checks = {
    'cr-display': function () {
      var v = display.value.trim();
      if (!v) return 'Enter the name to show on the leaderboard.';
      return v.length > 60 ? 'Keep this to 60 characters or fewer.' : '';
    },
    'cr-handle': function () {
      var v = handle.value.trim().replace(/^@+/, '');
      if (!v) return 'Enter the handle you will post from.';
      if (!/^[A-Za-z0-9._]{1,30}$/.test(v)) return 'Letters, numbers, full stops and underscores only.';
      // Instagram's own constraints. A handle it would never issue can never be
      // matched to a post, so it has to fail here rather than silently score zero.
      if (/^\./.test(v) || /\.$/.test(v)) return 'A handle cannot start or end with a full stop.';
      if (/\.\./.test(v)) return 'A handle cannot contain two full stops in a row.';
      return '';
    },
    'cr-email': function () {
      var v = email.value.trim();
      if (!v) return 'Enter your email address.';
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? '' : 'That does not look like an email address.';
    }
  };

  Object.keys(checks).forEach(function (id) {
    var el = form.querySelector('#' + id);
    if (!el) return;
    el.addEventListener('blur', function () { fieldErr(id, checks[id]()); });
    el.addEventListener('input', function () { fieldErr(id, ''); });
    el.addEventListener('change', function () { fieldErr(id, ''); });
  });

  function validate() {
    var firstBad = null;
    Object.keys(checks).forEach(function (id) {
      var msg = checks[id]();
      fieldErr(id, msg);
      if (msg && !firstBad) firstBad = id;
    });
    return firstBad;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;

    if (!live) {
      formErr.textContent = 'Registration is not open yet.';
      return;
    }

    var bad = validate();
    if (bad) {
      formErr.textContent = '';
      var target = form.querySelector('#' + bad);
      if (target) {
        target.scrollIntoView({ block: 'center', behavior: 'smooth' });
        if (target.focus) target.focus({ preventScroll: true });
      }
      return;
    }

    var payload = {
      display_name: display.value.trim(),
      platform: (form.querySelector('input[name="platform"]:checked') || form.querySelector('input[name="platform"]')).value,
      handle: handle.value.trim().replace(/^@+/, '').toLowerCase(),
      email: email.value.trim(),
      marketing_consent: form.querySelector('input[name="marketing_consent"]').checked
    };

    setState('loading');
    busy = true;
    formErr.textContent = '';

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      // A repeat is an expected answer rather than a failure, and it must not
      // read as one. The endpoint says which field collided. (No confirmation
      // email exists, so this must not send anyone to their inbox.)
      if (res.status === 409) {
        setState('idle');
        return res.json().catch(function () { return {}; }).then(function (b) {
          formErr.textContent = b && b.field === 'handle'
            ? 'That Instagram handle is already registered.'
            : 'That email is already registered.';
          return null;
        });
      }
      if (!res.ok) throw new Error('register-failed-' + res.status);
      return res.json().catch(function () { return {}; });
    }).then(function (data) {
      if (data === null) return;
      // Read the handle back. The leaderboard name is matched to it, so a typo
      // shows the person's posts under their bare handle for the whole contest and nothing
      // tells them why. This is the last moment they can see what we stored.
      // (No email is sent, so the message must not promise one.)
      var slot = inner.querySelector('.jangin-challenge-register__done-body');
      var tail = slot.textContent.trim();
      var strong = document.createElement('strong');
      strong.textContent = '@' + payload.handle;
      slot.textContent = '';
      slot.appendChild(document.createTextNode('Your leaderboard name will show next to '));
      slot.appendChild(strong);
      slot.appendChild(document.createTextNode(', so check that is the account you post from. ' + tail));
      setState('success');
      var sticky = document.querySelector('[data-challenge-sticky]');
      if (sticky) sticky.hidden = true;
      if (typeof gtag === 'function') gtag('event', 'challenge_registration');
      identifyToKlaviyo(payload.email);
      inner.querySelector('.jangin-challenge-register__done-heading').focus();
      // The code is registrants only, so it arrives here rather than in the page.
      // No code in the response, no popup: the link would check out at full price.
      if (data && data.offer_code) {
        applyDiscount(data.offer_code);
        openOffer(data.offer_code);
      }
    }).catch(function () {
      setState('idle');
      formErr.textContent = 'Something went wrong. Try again, and if it keeps happening email us.';
    }).then(function () { busy = false; });
  });

  // ---- Klaviyo identify ---------------------------------------------------
  // The backend tells Klaviyo who registered, but not which browser they are on, so
  // their carts and checkouts reached Klaviyo anonymous and no reminder could go out.
  // klaviyo.js (layout/theme.liquid) loads async: before it arrives, its _klOnsite
  // queue holds the call. Identifying never subscribes anyone.
  function identifyToKlaviyo(address) {
    if (!address) return;
    var props = { email: address };
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify(props);
      else (window._klOnsite = window._klOnsite || []).push(['identify', props]);
    } catch (e) { /* tracking must never break the success panel */ }
  }

  // ---- Discount on the cart -----------------------------------------------
  // Registrants who closed the popup and shopped on their own paid full price: the
  // code only lived in the popup link. Visiting /discount/CODE puts it on this
  // browser's cart, so whatever they add later is discounted. Redirecting to
  // /cart.js keeps the response tiny. The code still never appears in the page.
  function applyDiscount(code) {
    try {
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
        .catch(function () {});
    } catch (e) { /* a failed apply must never break the success panel */ }
  }

  // ---- Discount popup -----------------------------------------------------
  // Opens over the success panel. Closing it returns focus to the panel's
  // heading, which is where a screen reader user was before it opened.
  var offer = section.querySelector('[data-challenge-offer]');

  function openOffer(code) {
    if (!offer || typeof offer.showModal !== 'function' || offer.open) return;
    if (code) {
      var cta = offer.querySelector('[data-challenge-offer-cta]');
      cta.href = cta.getAttribute('href').split('?')[0] + '?discount=' + encodeURIComponent(code);
    }
    offer.showModal();
  }

  if (offer && typeof offer.showModal === 'function') {
    // Only the × closes it (Yohan): a stray tap on the backdrop or Escape dismissed
    // the offer before it was read, so neither closes the dialog any more.
    offer.querySelector('[data-challenge-offer-close]').addEventListener('click', function () { offer.close(); });
    offer.addEventListener('cancel', function (event) { event.preventDefault(); });
    offer.addEventListener('close', function () {
      var heading = inner.querySelector('.jangin-challenge-register__done-heading');
      if (inner.getAttribute('data-state') === 'success' && heading) heading.focus();
    });
    offer.querySelector('[data-challenge-offer-cta]').addEventListener('click', function () {
      if (typeof gtag === 'function') gtag('event', 'challenge_offer_click');
    });
    // Design preview on unpublished themes only. It has no code, so its link
    // checks out at full price.
    if (offer.hasAttribute('data-challenge-offer-preview') && /[?&]cr_offer=preview\b/.test(location.search)) openOffer();
  }

  // ---- Sticky bar ---------------------------------------------------------
  // Shown once the hero is out of view, hidden whenever the form itself is on
  // screen so it can never sit over the submit button.
  var sticky = document.querySelector('[data-challenge-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    var hero = document.querySelector('.jangin-challenge-hero');
    var heroVisible = true;
    var formVisible = false;

    function paint() {
      var done = inner.getAttribute('data-state') === 'success';
      sticky.hidden = heroVisible || formVisible || done;
    }
    if (hero) {
      new IntersectionObserver(function (es) {
        heroVisible = es[0].isIntersecting;
        paint();
      }, { threshold: 0 }).observe(hero);
    } else {
      heroVisible = false;
    }
    new IntersectionObserver(function (es) {
      formVisible = es[0].isIntersecting;
      paint();
    }, { threshold: 0 }).observe(section);
    paint();
  }
})();
